import axios from 'axios'
import {Blog} from 'types/blogs'

export const getWordPressBlogs = async (page_number = 1, query: string) => {
  try {
    let res = await axios.get(
      `https://blog.hybr1d.io/wp-json/wp/v2/posts?page=${page_number}&per_page=15${
        query ? query : ''
      }&_embed`,
    )
    return {
      blogs: res.data,
      page_number: page_number,
      total_blog: res.headers['x-wp-total'],
      total_page: res.headers['x-wp-totalpages'],
    }
  } catch (error) {
    console.error({error})
  }
}

export const getWordPressSearchedBlogs = async (searchText: string, page_number = 1) => {
  try {
    let res = await axios.get(
      `https://blog.hybr1d.io/wp-json/wp/v2/search?page=${page_number}&per_page=15&search=${searchText}&_embed`,
    )
    return {
      blogs: res.data,
      page_number: page_number,
      total_blog: res.headers['x-wp-total'],
      total_page: res.headers['x-wp-totalpages'],
    }
  } catch (error) {
    console.error({error})
  }
}

export const getWordPressCategories = async () => {
  try {
    let res = await axios.get('https://blog.hybr1d.io/wp-json/wp/v2/categories')
    return res.data
  } catch (error) {
    console.error({error})
  }
}

export const getWordPressTags = async () => {
  try {
    let res = await axios.get('https://blog.hybr1d.io/wp-json/wp/v2/tags?per_page=100')
    return res.data
  } catch (error) {
    console.error({error})
  }
}

export const getPostDetails = async (slug: string) => {
  try {
    let res = await axios.get(`https://blog.hybr1d.io/wp-json/wp/v2/posts?slug=${slug}&_embed`)
    console.log({res})
    return res.data[0]
  } catch (error) {
    console.error({error})
  }
}

export const getLatestThreeBlogs = async ({
  page_number = 1,
}: {
  page_number?: number
}): Promise<Blog[] | undefined> => {
  try {
    let res = await axios.get(
      `https://blog.hybr1d.io/wp-json/wp/v2/posts?page=${page_number}&per_page=4&_embed`,
    )
    return res.data
  } catch (error) {
    console.error({error})
  }
}
